// extracted by mini-css-extract-plugin
export default {"text":"Reauthenticate_text__A7UCd","title":"Reauthenticate_title__GuqJP","content":"Reauthenticate_content__UCY4G","input":"Reauthenticate_input__kom94"};